// Mirrors `.wf-input-wrap .form-control` in App.css so the encrypted MUI
// fields (SSN / phone / other) sit alongside the plain bootstrap inputs
// without looking like a different control. The label is rendered above by
// the caller, so these fields use a placeholder rather than a floating label.
const bprmFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "9px",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.03)",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    paddingRight: "8px",
    "& fieldset": {
      borderColor: "#cbd5e1",
      borderWidth: "1.5px",
    },
    "&:hover fieldset": {
      borderColor: "#94a3b8",
    },
    "&.Mui-focused": {
      backgroundColor: "#fafbff",
      boxShadow: "0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2563eb",
      borderWidth: "1.5px",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f8fafc",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#e2e8f0",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 13px",
    fontSize: "13px",
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 400,
    color: "#1e293b",
    height: "auto",
  },
  "& .MuiOutlinedInput-input::placeholder": {
    color: "#94a3b8",
    opacity: 1,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#555555",
    color: "#555555",
    opacity: 0.9,
  },
  "& .MuiFormHelperText-root": {
    fontSize: "12px",
    fontFamily: "Open Sans, sans-serif",
  },
  // Reveal / calendar adornment buttons. The explicit outline reset is load
  // bearing: a global button:focus rule otherwise draws a dark ring here.
  "& .MuiInputAdornment-root": {
    marginLeft: "2px",
  },
  // edge="end" ships a -12px right margin to sit flush with the border; the
  // input's own paddingRight supplies the gap instead.
  "& .MuiInputAdornment-root .MuiIconButton-edgeEnd": {
    marginRight: 0,
  },
  "& .MuiInputAdornment-root .MuiIconButton-root": {
    padding: "5px",
    borderRadius: "7px",
    color: "#94a3b8",
    transition: "color 0.2s ease, background-color 0.2s ease",
    outline: "none",
    boxShadow: "none",
    "& svg": {
      fontSize: "17px",
    },
    "&:hover": {
      backgroundColor: "rgba(37, 99, 235, 0.08)",
      color: "#2563eb",
    },
    "&:focus, &:focus-visible, &:active": {
      outline: "none",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      color: "#cbd5e1",
    },
  },
  // Only the "hide" button (rendered while the value is exposed) keeps a
  // colour, so a revealed SSN still reads as something to put back.
  "& .MuiInputAdornment-root .MuiIconButton-colorError": {
    color: "#dc2626",
    "&:hover": {
      backgroundColor: "rgba(220, 38, 38, 0.1)",
      color: "#b91c1c",
    },
  },
};

export default bprmFieldSx;
